module.exports = __webpack_public_path__ + "static/media/React-Params-List.a79716f2.png";